import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { info } from 'react-icons-kit/fa/info';
import { sort } from 'react-icons-kit/fa/sort';
import { enlarge } from 'react-icons-kit/icomoon/enlarge';
import { Icon } from 'react-icons-kit';
import { ic_radio_button_checked } from 'react-icons-kit/md/ic_radio_button_checked';
import { ic_radio_button_unchecked } from 'react-icons-kit/md/ic_radio_button_unchecked';

import ReactTooltip from 'react-tooltip';

import Info from 'components/Info/Info';
import Button from 'components/Button/Button';
import Pagination from 'components/Pagination/Pagination';
import CustomModal from 'components/CustomModal/CustomModal';
import ActionButton from 'components/ActionButton/ActionButton';

import Utils from 'utils/Utils';

import { setBboxTransform } from 'utils/Visor';

import './Results.css';

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      activePage: 0,
      rowLimit: 7,
      open: false,
      modalOption: undefined,
      order: 'innerTitle',
      asc: true,
      selected: {},
    };
  }

  componentWillMount = () => {
    this.sortResults(this.props.results, this.state.order);
  }

  sortResults = (results, order, order2) => {
    const asc = this.state.order === order ? !this.state.asc : true;
    let newResults = results.map((r) => {
      let newR = r;
      newR.innerTitle = `${r.title.split('(')[1].split(')')[0]} ${Utils.capitalize(r.title.split('(')[0])}`.trim();
      newR.innerShortTitle = `${r.title.split('(')[1].split(')')[0]} ${Utils.capitalize(r.title.split('(')[0].replace('Fotografías aéreas del ', ''))}`.trim();
      return newR;
    });

    newResults = Utils.sortArrayByProperty(newResults, order, asc, order2);
    this.setState({ results: newResults, activePage: 0, order: order, asc: asc });
  }

  changePage = (newPage) => {
    this.setState({ activePage: newPage });
  }

  onCloseModal = () => {
    this.setState({ open: false, modalOption: undefined });
  };

  showInfoPopup = (flight) => {
    this.setState({ open: true, modalOption: 'info', selected: flight });
  }

  selectFlight = (flight) => {
    this.setState({ selected: flight }, () => {
      this.props.setSelectedFlight(flight);
    });
  }

  zoomToFlight = (flight) => {
		if (flight.spatial !== undefined) {
			const coordinates = JSON.parse(flight.spatial).coordinates;
			setBboxTransform(coordinates);
		}
  }

  render() {
    const { t } = this.props;
    const { activePage, rowLimit, results, open, modalOption } = this.state;
    let renderResults = [];
    let limit = rowLimit + rowLimit * activePage;
    if (limit > results.length) {
      limit = results.length;
    }

    if (results.length > 0) {
      for (let i = (rowLimit * activePage); i < limit; i++) {
        const r = results[i];
        renderResults.push(
          <tr className='tableRow' key={'flight' + r.id}>
            <td className='tableRowCell left nomVuelo' data-tip data-for={r.id + 'tooltipName'}>
              {r.innerShortTitle.replaceAll('.', '') || '-'}
              <ReactTooltip id={r.id + 'tooltipName'} effect='solid' place='right'>
                <div>
                  <b>{r.innerTitle.replaceAll('.', '')}</b>
                </div>
              </ReactTooltip>
            </td>
            <td className='tableRowCell'>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ActionButton id={'flightInfo' + r.id} icon={info} size={'18px'}
                  color={'#006699'} tooltip={t('results.search_data')} onClick={this.showInfoPopup.bind(null, r)} />
                <ActionButton id={'flightZoom' + r.id} icon={enlarge} size={'14px'}
                  color={'#006699'} tooltip={t('results.to_zoom')} onClick={this.zoomToFlight.bind(null, r)} />
                <ActionButton id={'flightSelection' + r.id} icon={r.id === this.state.selected.id ? ic_radio_button_checked : ic_radio_button_unchecked} size={'18px'}
                  color={'#006699'} tooltip={t('results.select')} onClick={this.selectFlight.bind(null, r)} />
              </div>
            </td>
          </tr>
        );
      }
    }

    return (
      <Fragment>
        <div className='resultsContainer'>
          { results.length > 0 ?
            <Fragment>
              <div className='table row'>
                <div className='tableContainer'>
                  <table>
                    <thead>
                      <tr className='tableRowHeader'>
                        <th className='tableCell' onClick={this.sortResults.bind(null, this.state.results, 'innerTitle')}>
                          {t('results.name')}
                          <span className='sortButton'>
                            <Icon size={'8px'} icon={sort} />
                          </span>
                        </th>
                        <th className='tableCell'>{t('results.actions')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      { renderResults }
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='paginationContainer row' style={{ marginBottom: '10px' }}>
                <Pagination activePage={activePage} total={results.length}
                  rows={rowLimit} handlePageChange={this.changePage} />
                <Button text={t('filters.back')} active={true} onClick={this.props.clean} />
              </div>
            </Fragment>
          : <div>
              <div className='resultsTitleContainer row'><span>{t('results.results') + ' '} ({results.length})</span></div>
                <div className='paginationContainer row' style={{ marginBottom: '10px' }}>
                  <Button text={t('filters.back')} active={true} onClick={this.props.clean} />
                </div>
            </div> }
          { modalOption === 'info' ?
            <CustomModal open={open} onClose={this.onCloseModal} blocking={true} title={t('results.flight_info')}>
              <Info variant='flight' data={this.state.selected} />
            </CustomModal>
          : null }
        </div>
      </Fragment>
    );
  }
}

export default translate()(Results);
